import { render, staticRenderFns } from "./domain-company-section.html?vue&type=template&id=6281d972&scoped=true&"
import script from "./domain-company-section.js?vue&type=script&lang=js&"
export * from "./domain-company-section.js?vue&type=script&lang=js&"
import style0 from "./domain-company-section.scss?vue&type=style&index=0&id=6281d972&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6281d972",
  null
  
)

export default component.exports